export default "__VITE_ASSET__CQtcfKVT__"